import { Inject, Injectable } from '@angular/core';

import { IBetslip } from '../../../../../../bet-generation/models';
import { BetslipError } from '../../../../../errors/betslip-error';
import { PURE_BETSLIP_VALIDATORS } from '../../../../betslip-validation-injection-tokens';
import { IPureBetslipValidator } from '../../../../validators/betslip/validators';
import { IBetslipValidationComposer } from '../../betslip-validation-composers';

@Injectable()
export class PureBetslipValidationComposerService implements IBetslipValidationComposer {
    constructor(@Inject(PURE_BETSLIP_VALIDATORS) private pureBetslipValidators: IPureBetslipValidator<BetslipError>[]) {}

    validateBetslip(betslip: IBetslip): BetslipError[] {
        return this.pureBetslipValidators.flatMap((v) => Array.from(v.validate(betslip)));
    }
}
